import "core-js/modules/es.array.push.js";
import { paperList } from '@/api/mg';
export default {
  data: function data() {
    return {
      title: 'Questionnaire',
      questions: []
    };
  },
  created: function created() {
    this.getPaperList({
      page: 1,
      perPage: 10
    });
  },
  methods: {
    getPaperList: function getPaperList(params) {
      var _this = this;
      paperList(params).then(function (res) {
        if (res.Code === 0) {
          _this.questions = res.Data.pageData;
        } else {
          _this.$message.error(res.Message);
        }
      });
    },
    back: function back() {
      var _this2 = this;
      var timer = setTimeout(function () {
        _this2.$router.back();
        clearTimeout(timer);
      }, 100);
    },
    toAnswer: function toAnswer(id) {
      this.$router.push({
        path: '/social/question',
        query: {
          id: id
        }
      });
    }
  }
};